import React from 'react'
import { Icon } from 'antd';

const modifyUserInfo = () => {
  tool.popSingleUI("/ModifyUserInfo");
}
export default function UserInfos(props) {
  return (
    <div className={props.className} onClick={modifyUserInfo}>
        <Icon type="appstore" />
        &nbsp;&nbsp;&nbsp;
        <span>查看用户信息</span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./apps/pages/main/layout/operation/UserInfos.js